// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#event-schedule-desc .ql-editor {\n  height: 250px !important;\n}\n", ""]);
// Exports
module.exports = exports;
